export function string(from, to) {
    const _to = to;
    if (from === _to)
        return { result: 'equal' };
    const to_at = _to.indexOf(from);
    if (to_at !== -1)
        return {
            result: 'substring',
            before: _to.slice(0, to_at),
            after: _to.slice(to_at + from.length),
            add: true,
        };
    const from_at = from.indexOf(_to);
    if (from_at !== -1)
        return {
            result: 'substring',
            before: from.slice(0, from_at),
            after: from.slice(from_at + _to.length),
            add: false,
        };
    return { result: 'not-equal' };
}
export function number(from, to) {
    const _to = to;
    if (Number.isNaN(to) || Number.isNaN(from)) {
        return { type: 'number', result: 'not-equal' };
    }
    if (!Number.isFinite(to) || !Number.isFinite(from)) {
        return { type: 'number', result: _to === from ? 'equal' : 'not-equal' };
    }
    if (_to === from)
        return { type: 'number', result: 'equal' };
    return { type: 'number', result: 'diff', value: from - to };
}
export function bigint(from, to) {
    const _to = to;
    if (_to === from)
        return { type: 'bigint', result: 'equal' };
    return { type: 'bigint', result: 'diff', value: from - to };
}
export function boolean(from, to) {
    return { type: 'boolean', result: !!to === !!from ? 'equal' : 'not-equal' };
}
export function functionRT(from, to) {
    if (from.length === to.length) {
        return { type: 'function', result: 'equal' };
    }
    return { type: 'function', result: 'diff-arg', argCount: from.length - to.length };
}
export function array(from, to) {
    const lengthDiff = from.length - to.length, changed = [];
    let neq = false;
    for (let i = 0; i < Math.min(from.length, to.length); i++) {
        const diff = deep(from[i], to[i]);
        changed.push(diff);
        if (diff.result !== 'equal')
            neq = true;
    }
    return (!neq && !lengthDiff
        ? { type: 'array', result: 'equal' }
        : { type: 'array', result: 'diff', elements: lengthDiff, changed });
}
export function object(from, to) {
    const fromKeys = new Set(Object.keys(from)), toKeys = new Set(Object.keys(to));
    const removed = fromKeys.difference(toKeys), added = toKeys.difference(fromKeys);
    const changed = Object.create(null);
    let neq = false;
    for (const key of fromKeys.intersection(toKeys)) {
        changed[key] = deep(from[key], to[key]);
        if (changed[key].result !== 'equal')
            neq = true;
    }
    return (neq || removed.size || added.size
        ? { type: 'object', result: 'diff', removed: Array.from(removed), added: Array.from(added), changed }
        : { type: 'object', result: 'equal' });
}
export function deep(from, to) {
    const rt = (value) => value;
    switch (typeof from) {
        case 'string':
            if (['symbol', 'function', 'object'].includes(typeof to))
                break;
            return rt({
                type: 'string',
                coerced: typeof to !== 'string',
                ...string(from, `${to}`),
            });
        case 'number':
            if (typeof to == 'number')
                return rt({ ...number(from, to), coerced: false });
            if (typeof to == 'bigint')
                return rt({ ...number(from, Number(to)), coerced: true });
            break;
        case 'bigint':
            if (typeof to == 'bigint')
                return rt({ ...bigint(from, to), coerced: false });
            if (typeof to == 'number')
                return rt({ ...bigint(from, BigInt(to)), coerced: true });
            break;
        case 'boolean':
            if (typeof to == 'boolean')
                return rt({ ...boolean(from, to), coerced: false });
            if (!to)
                return rt({ ...boolean(from, false), coerced: true });
            break;
        case 'symbol':
            if (typeof to !== 'symbol')
                break;
            return rt({ type: 'symbol', result: from == to ? 'equal' : 'not-equal' });
        case 'undefined':
            if (to === undefined)
                return rt({ type: 'undefined', result: 'equal', coerced: false });
            if (!to)
                return rt({ type: 'undefined', result: 'equal', coerced: true });
            break;
        case 'function':
            if (typeof to !== 'function')
                break;
            return rt({ ...functionRT(from, to) });
        case 'object':
            if (from === null) {
                if (to === null)
                    return rt({ type: 'null', result: 'equal', coerced: false });
                if (!to)
                    return rt({ type: 'null', result: 'equal', coerced: true });
                break;
            }
            if (typeof to != 'object' || !to)
                break;
            if (Array.isArray(from)) {
                if (!Array.isArray(to))
                    break;
                return rt(array(from, to));
            }
            return rt(object(from, to));
    }
    return rt({ result: 'not-comparable' });
}
